import { merge } from 'ramda';

import {
  LOAD_PLANNER_REQUESTS_REQUEST, LOAD_PLANNER_REQUESTS_SUCCESS, LOAD_PLANNER_REQUESTS_FAIL,
  POST_PLANNER_REQUEST_REQUEST, POST_PLANNER_REQUEST_SUCCESS, POST_PLANNER_REQUEST_FAIL,
  PUT_MULTIPLE_PLANNER_REQUESTS_REQUEST, PUT_MULTIPLE_PLANNER_REQUESTS_SUCCESS, PUT_MULTIPLE_PLANNER_REQUESTS_FAIL,
  PUT_PLANNER_REQUEST_REQUEST, PUT_PLANNER_REQUEST_SUCCESS, PUT_PLANNER_REQUEST_FAIL,
  DELETE_PLANNER_REQUESTS_REQUEST, DELETE_PLANNER_REQUESTS_SUCCESS, DELETE_PLANNER_REQUESTS_FAIL,
  POST_PLANNER_REQUEST_CONFIRMATION_REQUEST, POST_PLANNER_REQUEST_CONFIRMATION_SUCCESS, POST_PLANNER_REQUEST_CONFIRMATION_FAIL,
  LOAD_PLANNER_REQUESTS_TYPES_REQUEST, LOAD_PLANNER_REQUESTS_TYPES_SUCCESS, LOAD_PLANNER_REQUESTS_TYPES_FAIL,
  POST_PLANNER_REQUESTS_TYPES_REQUEST, POST_PLANNER_REQUESTS_TYPES_SUCCESS, POST_PLANNER_REQUESTS_TYPES_FAIL,
  PUT_PLANNER_REQUESTS_TYPES_REQUEST, PUT_PLANNER_REQUESTS_TYPES_SUCCESS, PUT_PLANNER_REQUESTS_TYPES_FAIL,
  DELETE_PLANNER_REQUESTS_TYPES_REQUEST, DELETE_PLANNER_REQUESTS_TYPES_SUCCESS, DELETE_PLANNER_REQUESTS_TYPES_FAIL
} from 'src/store/actions/plannerRequestsActions';

const initialState = {
  types: [],
  typesFetching: false,
  typesOptions: [],
  plannerRequests: [],
  plannerRequestsFetching: false,
  dataLoaded: false
};

const typesToOptions = (list) => list.map(({ Id, Name }) => ({ label: Name, value: String(Id) }));

const replaceInList = (list, newList) => {
  const newItemsObject = newList.reduce((counter, item) => ({ ...counter, [item.Id]: item }), {});
  return list.map((item) => (newItemsObject[item.Id] ? newItemsObject[item.Id] : item));
};

const plannerRequestsReducer = (state = initialState, action) => {
  switch (action.type) {
    case POST_PLANNER_REQUEST_REQUEST:
    case PUT_MULTIPLE_PLANNER_REQUESTS_REQUEST:
    case PUT_PLANNER_REQUEST_REQUEST:
    case DELETE_PLANNER_REQUESTS_REQUEST:
    case POST_PLANNER_REQUEST_CONFIRMATION_REQUEST:
      return merge(state, { plannerRequestsFetching: true });
    case LOAD_PLANNER_REQUESTS_REQUEST:
      return merge(state, { plannerRequestsFetching: true, dataLoaded: false });
    case LOAD_PLANNER_REQUESTS_SUCCESS:
      return merge(state, {
        plannerRequestsFetching: false,
        plannerRequests: action.payload,
        dataLoaded: true
      });
    case POST_PLANNER_REQUEST_SUCCESS:
      if (state.dataLoaded) {
        return merge(state, { plannerRequests: [...state.plannerRequests, action.payload], plannerRequestsFetching: false });
      } else {
        return merge(state, { plannerRequestsFetching: false });
      }
    case PUT_PLANNER_REQUEST_SUCCESS:
      return merge(state, {
        plannerRequests: replaceInList(state.plannerRequests, [action.payload]),
        plannerRequestsFetching: false
      });
    case PUT_MULTIPLE_PLANNER_REQUESTS_SUCCESS:
    case POST_PLANNER_REQUEST_CONFIRMATION_SUCCESS:
      return merge(state, { plannerRequests: replaceInList(state.plannerRequests, action.payload), plannerRequestsFetching: false });
    case DELETE_PLANNER_REQUESTS_SUCCESS:
      return merge(state, {
        plannerRequests: state.plannerRequests.filter(({ Id }) => !action.payload.includes(Id)),
        plannerRequestsFetching: false
      });
    case POST_PLANNER_REQUEST_FAIL:
    case PUT_MULTIPLE_PLANNER_REQUESTS_FAIL:
    case PUT_PLANNER_REQUEST_FAIL:
    case DELETE_PLANNER_REQUESTS_FAIL:
    case POST_PLANNER_REQUEST_CONFIRMATION_FAIL:
      return merge(state, { plannerRequestsFetching: false });
    case LOAD_PLANNER_REQUESTS_FAIL:
      return merge(state, { plannerRequestsFetching: false, dataLoaded: false });
    case LOAD_PLANNER_REQUESTS_TYPES_REQUEST:
    case POST_PLANNER_REQUESTS_TYPES_REQUEST:
    case PUT_PLANNER_REQUESTS_TYPES_REQUEST:
    case DELETE_PLANNER_REQUESTS_TYPES_REQUEST:
      return merge(state, { typesFetching: true });
    case LOAD_PLANNER_REQUESTS_TYPES_SUCCESS:
      return merge(state, {
        typesFetching: false,
        types: action.payload,
        typesOptions: typesToOptions(action.payload)
      });
    case POST_PLANNER_REQUESTS_TYPES_SUCCESS: {
      const newTypes = [...state.types, action.payload];
      return merge(state, { types: newTypes, typesOptions: typesToOptions(newTypes), typesFetching: false });
    }
    case PUT_PLANNER_REQUESTS_TYPES_SUCCESS: {
      const newTypes = replaceInList(state.types, [action.payload]);
      return merge(state, { types: newTypes, typesOptions: typesToOptions(newTypes), typesFetching: false });
    }
    case DELETE_PLANNER_REQUESTS_TYPES_SUCCESS: {
      const newTypes = state.types.filter(({ Id }) => !action.payload.includes(Id));
      return merge(state, { types: newTypes, typesOptions: typesToOptions(newTypes), typesFetching: false });
    }
    case LOAD_PLANNER_REQUESTS_TYPES_FAIL:
    case POST_PLANNER_REQUESTS_TYPES_FAIL:
    case PUT_PLANNER_REQUESTS_TYPES_FAIL:
    case DELETE_PLANNER_REQUESTS_TYPES_FAIL:
      return merge(state, { typesFetching: false });
    default:
      return state;
  }
};

export default plannerRequestsReducer;
